import React, { useState, useEffect } from "react";
import { isRequired } from "./BriefUtils";
import BriefDropdownList from "../../components/BriefDropDownList/BriefDropdownList";
import { Globals } from "../../global/Globals";
import RadioButton from "../../components/RadioButton/RadioButton"; // Import the RadioButton component
import { useSelector, useDispatch } from "react-redux";
import { setIsProducerDetailsAtLeastPartiallyFilled } from "./CreateBriefSlice";
import { useLanguage } from '../../context/Languagecontext';
import FallBackLabel from '../../global/Globals_Eng.json';
export const ProducerInformation = ({
  closedBrief,
  handleRadioButton,
  handleTitleSelection,
  propsData,
  handleProducerData,
}) => {
  const { Globals ,languages, setLanguages } = useLanguage();
  const [briefType, setBriefType] = useState(propsData?.proposalType || 0);
  const dispatch = useDispatch();
  const isSaveAsDraftClicked = useSelector(state => state.createBrief.isSaveAsDraftClicked);
  const isProducerDetailsValid = useSelector(state => state.createBrief.isProducerDetailsValid);
  const [formData, setFormData] = useState({
    BRIEF_TYPE: propsData?.proposalType || 0,
    PRODUCERS: propsData?.producers || [],
  });

  useEffect(() => {
    handleProducerData(formData);
  }, [formData]);

  const raidoButtonSelection = (type, value) => {
    setFormData((prevData) => ({
      PRODUCERS: [],
      BRIEF_TYPE: type,
    }));
    setBriefType(type);
    handleRadioButton(type, value);
  };

  const handleSelect = (dropdownName, selectedValues) => {
    setFormData((prevData) => ({
      ...prevData,
      PRODUCERS: briefType === 2 ? selectedValues : [],
    }));
    setIsProducersListInValid(false);
  };

  const [isProducersListInvalidValid, setIsProducersListInValid] = useState(false);
  const validateProducersList = () => {
    setIsProducersListInValid((prevState) => ({
      ...prevState,
    isProducersListInvalidValid:formData.PRODUCERS.length === 0
      ? true:false
    }));
  }

  // useEffect(() => {
  //   if (isSaveAsDraftClicked === true && isProducerDetailsValid === false && formData.BRIEF_TYPE === 2) {
  //     validateProducersList();
  //   }
  // }, [isSaveAsDraftClicked, isProducerDetailsValid])

  useEffect(() => {
    const doesFormHaveValue = formData.BRIEF_TYPE === 2 && formData.PRODUCERS.length > 0;
    dispatch(setIsProducerDetailsAtLeastPartiallyFilled({ isProducerPartiallyFilled: doesFormHaveValue }));
  })
  return (
    <div className="brief-container">
      <label className="brief-basic-details-text">
        {Globals.CREATE_NEW_BRIEF.PRODUCER_INFORMATION}
      </label>
      <div className="brief-form-row">
        <div className={`${languages === 'kw' ? 'brief-form-group-kw' : 'brief-form-group'}`}>
          {isRequired(Globals.CREATE_NEW_BRIEF.BRIEF_TYPE, true)}
          <div className="brief-radio-group">
            <RadioButton
              name={Globals.CREATE_NEW_BRIEF.BRIEF_TYPE}
              value="0"
              label={Globals.CREATE_NEW_BRIEF.OPEN_BRIEF}
              onClick={() =>
                raidoButtonSelection(0, Globals.CREATE_NEW_BRIEF.OPEN_BRIEF)
              }
              defaultChecked={formData.BRIEF_TYPE.toString() === "0"}
            />
            <RadioButton
              name={Globals.CREATE_NEW_BRIEF.BRIEF_TYPE}
              value="2"
              label={Globals.CREATE_NEW_BRIEF.CLOSE_BRIEF}
              onClick={() =>
                raidoButtonSelection(2, Globals.CREATE_NEW_BRIEF.CLOSE_BRIEF)
              }
              defaultChecked={formData.BRIEF_TYPE.toString() === "2"}
            />
          </div>
        </div>
        <div className={`${languages === 'kw' ? 'brief-form-group-kw' : 'brief-form-group'}`}>
          {formData.BRIEF_TYPE === 2 && (
            <>
              <label className="brief-input-top-label-brief">
                {Globals.CREATE_NEW_BRIEF.PRODUCERS}{" "}
                <span className="required"> *</span>
              </label>
              <span onBlur={validateProducersList} tabIndex={13}>
              <BriefDropdownList
                name="PRODUCERS"
                value={formData.PRODUCERS}
                filterName="PRODUCERS"
                title=""
                isDatePicker={false}
                onSelect={handleSelect}
                className="dropdown-width-300"
              />
              {(isProducersListInvalidValid&&formData.PRODUCERS.length===0)&&<div><img id="login-error" className="login-error" src={Globals.IMG.ERROR} alt="error" /><label className='invalidCredential'>{Globals.CREATE_NEW_BRIEF_ERROR_MESSAGES.PRODUCER_LIST}</label></div>}
              </span>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
